import React from "react"
import { useAdminPreviewDocuments, useAdminPreviewDocument } from "@/lib/queries"
import { WorkflowsListView } from "@/components/shared/WorkflowsListView"

const pdfUrl = (workflowSlug: string, crSlug: string, activityId?: number) =>
  `/api/v1/admin/preview_documents/${workflowSlug}/pdf?clinical_review=${encodeURIComponent(crSlug)}${activityId ? `&activity=${activityId}` : ""}`

export function AdminWorkflowsPage() {
  const { data: docs = [], isLoading } =
    useAdminPreviewDocuments("workflow_template")

  return (
    <WorkflowsListView
      docs={docs}
      isLoading={isLoading}
      useDocumentDetail={useAdminPreviewDocument}
      pdfUrl={pdfUrl}
    />
  )
}
